import ProducerAddressInterface, { AddressType } from "@app/Interface/ProducerAddressInterface";

export default class ProducerAddressModel implements ProducerAddressInterface {
    addressId: number;
    producerId: number;
    type: AddressType;
    street1: string;
    street2: string;
    city: string;
    state: string;
    postal: string;
    
    constructor() {

        this.producerId = 0;
        this.addressId = 0;
        this.type = AddressType.Farm;
        this.street1 = "";
        this.street2 = "";
        this.city = "";
        this.state = "";
        this.postal = "";

    }

}